import React from "react";
import { connect } from "react-redux";
import "../App.css";
import { REQUIRE_AUTH, REDIRECT } from '../constants/actionTypes';

import { withRouter } from "react-router";

class Hidden extends React.Component {
    componentWillReceiveProps({redirectTo}) {
        if (redirectTo) {
            this.props.history.push(redirectTo);
            this.props.onRedirect();
        }
    }

    componentWillMount() {

        const {user} = this.props;

        if (!user) {
            this.props.requireAuth();
        }

    }


    render() {
        if (this.props.user) {
          return (<div>{this.props.children}</div>)
        } else {
          return null
        }
    }
}

const mapStateToProps = state => ({
    user: state.common.user,
    redirectTo: state.common.redirectTo,
});

const mapDispatchToProps = dispatch => ({
    requireAuth: () =>
        dispatch({ type: REQUIRE_AUTH, prevPath: window.location.pathname}),
    onRedirect: () =>
        dispatch({type: REDIRECT})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Hidden));



// WEBPACK FOOTER //
// ./src/components/Hidden.js